import { render, staticRenderFns } from "./addFormation.vue?vue&type=template&id=0aed4290&scoped=true"
import script from "./addFormation.vue?vue&type=script&lang=js"
export * from "./addFormation.vue?vue&type=script&lang=js"
import style0 from "./addFormation.vue?vue&type=style&index=0&id=0aed4290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed4290",
  null
  
)

export default component.exports